import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { PostalAddress } from './PostalAddress'
import { WarehouseWorkingHours } from './WarehouseWorkingHours'
/**
* Class WebPickupPointDto
*  Точка выдачи для витрины
*/
export class WebPickupPointDto extends ActiveModel {

  /**
  * warehouseId
  * Идентификатор склада — его покупатель передаёт при оформлении  */
  @ActiveField(0)
  warehouseId: number = 0


/**
  * name
  * Название точки: публичное имя склада, иначе его название
  */
  @ActiveField('')
  name: string = ''


  /**
  * address
  * Собственный адрес склада. Обязателен на входе API; в базе допускает<br>`null`, потому что миграция не может выдумать адрес складам,<br>у которых не было привязки к справочнику СДЭК.<br>  */
  @ActiveField({
    factory: [PostalAddress, () => PostalAddress.create()]
  })
  address: PostalAddress = PostalAddress.create()


  /**
  * workingHours
  * Режим работы точки.  */
  @ActiveField({
    factory: [WarehouseWorkingHours, () => undefined]
  })
  workingHours?: null | WarehouseWorkingHours


/**
  * phone
  * Телефон точки.
  */
  @ActiveField()
  phone?: null | string


/**
  * instruction
  * Как забрать заказ: этаж, вход, что взять с собой.
  */
  @ActiveField()
  instruction?: null | string
}
